import React from 'react'

const colors = {
  white: {
    stopColor: '#E0E0E0',
    color: '#FFF',
  },
  black: {
    stopColor: '#000',
    color: '#000',
  },
}

const SvgStar = ({ isBlack = false, ...props }) => {
  const color = isBlack ? colors.black : colors.white

  return (
    <svg width="1em" height="1em" viewBox="0 0 33 32" fill="none" {...props}>
      <defs>
        <linearGradient
          id="Star_svg__paint0_linear"
          x1={16.5}
          y1={0}
          x2={16.5}
          y2={32}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color.stopColor} />
          <stop offset={0.51} stopColor={color.stopColor} stopOpacity={0} />
          <stop offset={1} stopColor={color.stopColor} />
        </linearGradient>
      </defs>
      <path
        d="M24.212 0c-1.768 4.61-3.52 9.238-5.305 13.934l12.08-7.82c.052.085.087.17.14.255-3.904 2.732-7.808 5.465-11.817 8.265 4.64.376 9.173.734 13.69 1.093-.087.188-.175.392-.263.58-4.849.359-9.716.718-14.705 1.093 1.558 3.074 3.064 6.08 4.587 9.102-.105.068-.21.136-.298.204-1.768-2.834-3.536-5.686-5.357-8.589-2.556 4.696-5.042 9.29-7.545 13.883-.193 0-.403 0-.596-.017 1.751-4.576 3.502-9.17 5.322-13.883-4.219 2.715-8.368 5.396-12.517 8.077-.052-.085-.087-.154-.14-.239 4.062-2.834 8.123-5.67 12.255-8.555A2367.34 2367.34 0 0 1 0 16.29c.088-.17.158-.358.245-.53 4.85-.358 9.734-.733 14.776-1.109-1.54-3.022-3.064-5.994-4.57-8.982.105-.068.21-.154.316-.222 1.75 2.8 3.5 5.618 5.287 8.487C18.627 9.22 21.113 4.61 23.616 0c.193.017.403 0 .596 0z"
        fill={color.color}
      />
      <path
        d="M24.212 0c-1.768 4.61-3.52 9.238-5.305 13.934l12.08-7.82c.052.085.087.17.14.255-3.904 2.732-7.808 5.465-11.817 8.265 4.64.376 9.173.734 13.69 1.093-.087.188-.175.392-.263.58-4.849.359-9.716.718-14.705 1.093 1.558 3.074 3.064 6.08 4.587 9.102-.105.068-.21.136-.298.204-1.768-2.834-3.536-5.686-5.357-8.589-2.556 4.696-5.042 9.29-7.545 13.883-.193 0-.403 0-.596-.017 1.751-4.576 3.502-9.17 5.322-13.883-4.219 2.715-8.368 5.396-12.517 8.077-.052-.085-.087-.154-.14-.239 4.062-2.834 8.123-5.67 12.255-8.555A2367.34 2367.34 0 0 1 0 16.29c.088-.17.158-.358.245-.53 4.85-.358 9.734-.733 14.776-1.109-1.54-3.022-3.064-5.994-4.57-8.982.105-.068.21-.154.316-.222 1.75 2.8 3.5 5.618 5.287 8.487C18.627 9.22 21.113 4.61 23.616 0c.193.017.403 0 .596 0z"
        fill="url(#Star_svg__paint0_linear)"
      />
    </svg>
  )
}

export default SvgStar
